import { useSuspenseQuery } from '@tanstack/react-query';
import { createFileRoute } from '@tanstack/react-router';

import { useTranslations } from '~/i18n/use-translations.ts';
import { getInstrumentOwnershipPageDataQueryOptions } from '~/server/instrument/instrument-ownership-page-data-query.ts';

export const Route = createFileRoute('/instrument/$ticker/ownership')({
	component: InstrumentOwnershipPage,
	loader: ({ context, params }) =>
		context.queryClient.ensureQueryData(getInstrumentOwnershipPageDataQueryOptions({ ticker: params.ticker })),
});

function InstrumentOwnershipPage() {
	const t = useTranslations();
	const { ticker } = Route.useParams();
	const { data } = useSuspenseQuery(getInstrumentOwnershipPageDataQueryOptions({ ticker }));
	const { ownershipData } = data;

	if (ownershipData) {
		return (
			<div className="mt-1 pr-4 pl-2">
				<OwnershipTable />
			</div>
		);
	}

	return (
		<div className="flex h-full w-full justify-center">
			<div className="flex flex-col">
				<span className="mt-40 text-foreground italic">{t('instrument.noOwnership')}</span>
				<span className="text-foreground text-sm italic">(?) info@eqity.app</span>
			</div>
		</div>
	);
}

function OwnershipTable() {
	const t = useTranslations();
	return <div className="border border-border p-2">{t('instrument.ownershipTable')}</div>;
}
